/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const newsletterNav = [
  {
    name: "Money Order",
    id: "Money Order",
    url: "/newsletter/money-order"
  },
  {
    name: "Bull's Eye",
    id: "Bulls Eye",
    url: "/newsletter/bulls-eye"
  },
  {
    name: "Monthly Updates",
    id: "Monthly Updates",
    url: "/newsletter/monthly-updates"
  },
  {
    name: "Big Picture (Archived)",
    id: "Big Picture",
    url: "/newsletter/big-picture"
  }
];

export default newsletterNav;
